import { render, staticRenderFns } from "./locale-dropdown.vue?vue&type=template&id=1ed71834&"
import script from "./locale-dropdown.vue?vue&type=script&lang=js&"
export * from "./locale-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports